<vlp-tenant-selector
    *ngIf="canSelectTenant"
    [class.min-w-72]="!compact"
    source="platform"
    [value]="tenantId"
    [showAll]="showAll"
    [allowClear]="false"
    [label]="compact ? '' : ('tenantAdmin.selectTenant' | transloco)"
    [labelMode]="compact ? 'hidden' : 'floating'"
    [dropDownMinWidth]="compact ? 420 : 560"
    (valueChange)="onTenantChanged($event)"
></vlp-tenant-selector>
